import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {CollectionService} from '../../../Services/collection.service';
import {Router} from '@angular/router';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {SystemUser} from '../../../../shared/Models/SystemUser';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-archive-collection-view',
  templateUrl: './archive-collection-view.component.html',
  styleUrls: ['./archive-collection-view.component.scss']
})
export class ArchiveCollectionViewComponent implements OnInit {

  public grid: Grid;
  public collectionId: number;
  public collectionName: string;

  @ViewChild('collectionRowDetail', {static: false}) collectionRowDetail: any;
  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(
    private router: Router,
    private collectionService: CollectionService,
    private broadcastService: BroadcastService,
    private translateService: TranslateService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.collection.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.attributes.model',
          prop: 'modelCount',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.user.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.collectionId = row.id;
                this.collectionName = row.name.bold();
                this.readdModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.collectionService,
      rememberURL: this.router.url,
      method: 'getCollection',
      defaultSort: 'name',
      rowDetailTemplate: this.collectionRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      archive: true ,
    };
  }

  readdCollection() {
    this.collectionService.readdCollection(this.collectionId).subscribe((res) => {
      this.broadcastService.broadcast('refreshGrid', 'getCollection');
      this.readdModal.hide();
    });
  }

}
